import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

//-----------------Icons----------------------
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Calender } from "../../assets/icons/calendar.svg";
import { ReactComponent as Compass } from "../../assets/icons/compass.svg";
import { ReactComponent as Multiple } from "../../assets/icons/multiple-documents.svg";
import { ReactComponent as Document } from "../../assets/icons/document.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";

// -----------PDFViewer imports----------------
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import { searchPlugin } from "@react-pdf-viewer/search";
import {
  convertArabicToNumber,
  convertToArabicDate,
  toArabicNumber,
} from "../../utils/arabicConversions";
import "../../styles-arabic/pdf-modal.rtl.css";

import { toast } from "react-toastify";

const TOAST_IDS = {
  copySuccess: "arabic-pdf-viewer-copy-success",
};

const PdfViewerModalArabic = ({ show, handleClose, searchQuery, row }) => {
  //todo Using hook

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    renderToolbar: (Toolbar) => (
      <Toolbar>
        {(slots) => {
          const {
            ZoomIn,
            ZoomOut,
            SwitchTheme,
            EnterFullScreen,
            Print,
            Download,
          } = slots;

          const isArabic =
            typeof window !== "undefined" &&
            localStorage.getItem("lang") === "ar";

          return (
            <div
              className={`rpv-toolbar pdf-viewer-toolbar-wrapper ${
                isArabic ? "rpv-toolbar--rtl" : ""
              }`}
              role="toolbar"
              aria-orientation="horizontal"
            >
              <div className="pdf-viewer-toolbar">
                <div className="pdf-viewer-toolbar__group">
                  <ZoomOut />
                  <ZoomIn />
                </div>
                <div className="pdf-viewer-toolbar__group">
                  <SwitchTheme />
                  <EnterFullScreen />
                  <Print />
                  <Download />
                </div>
              </div>
            </div>
          );
        }}
      </Toolbar>
    ),
  });

  const pageNavigationPluginInstance = pageNavigationPlugin();
  let searchPluginInstance = searchPlugin();
  if (searchQuery !== "") {
    searchPluginInstance = searchPlugin({
      keyword: searchQuery?.split(" "),
      highlightAll: true,
      onHighlightKeyword: (props) => {
        props.highlightEle.style.backgroundColor = "rgba(255, 255, 0, .5)";
        // props.highlightEle.style.border = "1px solid rgba(255, 165, 0, 0.8)";
        //! Uncomment for orange shadow on highlight
        // props.highlightEle.style.boxShadow = "0 0 5px rgba(255, 0, 0, 0.6)";
      },
    });
  }

  const [maxPage, setMaxPage] = useState(row?.number_of_pages || 0);
  const [page, setPage] = useState(row?.page_number || 0);
  const [pdfUrl, setPDFurl] = useState(row?.AWS_link || "");

  //Page number feature
  const [enteredPageNumber, setEnteredPageNumber] = useState("");

  const handlePageNumberChange = (e) => {
    const inputValue = e.target.value;
    setEnteredPageNumber(inputValue);
  };

  const navigateToEnteredPage = () => {
    const pageNumber = convertArabicToNumber(enteredPageNumber);
    if (pageNumber >= 1 && pageNumber <= maxPage) {
      setPage((prevPage) => {
        setPDFurl(get_new_file(pageNumber));
        return pageNumber;
      });
    }
  };

  const viewerPluginInstances = [
    defaultLayoutPluginInstance,
    pageNavigationPluginInstance,
    searchPluginInstance,
  ];

  useEffect(() => {
    if (pdfUrl) {
      viewerPluginInstances.forEach((plugin) => {
        if (plugin && typeof plugin.setCurrentPage === "function") {
          plugin.setCurrentPage(enteredPageNumber);
        }
      });
    }
  }, [pdfUrl, enteredPageNumber]);

  useEffect(() => {
    if (row) {
      setMaxPage(row.number_of_pages);
      setPage(row.page_number || 1);
      setPDFurl(row.AWS_link);
    }
  }, [row]);

  const {
    coll_name_arabic,
    date,
    date_of_journal,
    coll_location_arabic,
    coll_source_arabic,
    coll_type,
    date_of_publication,
    issue_number,
    volume,
    AWS_link,
    authors_arabic,
    title_arabic,
    place_of_publication_arabic,
    publisher_arabic,
  } = row || {};
  let fixedDate = date || date_of_journal;

  if (fixedDate) fixedDate = convertToArabicDate(fixedDate);

  // Copy citation

  const [copySuccess, setCopySuccess] = useState("");

  let citationText;

  if (coll_type === "periodical") {
    citationText = `${coll_name_arabic}، المجلد ${volume}، العدد ${issue_number}، ${
      coll_type === "periodical" ? fixedDate : date_of_publication
    }، مركز الخيرالله لدراسات الانتشار اللبناني arabicsearch.org، ${coll_source_arabic}، ${AWS_link}`;
  } else {
    // First name Last name, Title, (Place of Publication: Publisher, Year), Khayrallah Center for Lebanese Diaspora Studies arabicsearch.org.
    citationText = `\u202B${authors_arabic}، ${title_arabic}، (${place_of_publication_arabic}: ${publisher_arabic}، ${date_of_publication})، Khayrallah Center for Lebanese Diaspora Studies arabicsearch.org، ${AWS_link}\u202C`;
  }

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(citationText);
      setCopySuccess("تم النسخ!");
      setTimeout(() => setCopySuccess(""), 2000);
    } catch (err) {
      setCopySuccess("فشل النسخ");
    }
  };

  const get_new_file = (currentPage) => {
    const prefix = pdfUrl.split("_").slice(0, -1).join("_");
    return `${prefix}_${currentPage}.pdf`;
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage((prevPage) => {
        const newPage = prevPage - 1;
        setPDFurl(get_new_file(newPage));
        return newPage;
      });
    }
  };

  const handleNextPage = () => {
    if (page < maxPage) {
      setPage((prevPage) => {
        const newPage = prevPage + 1;
        setPDFurl(get_new_file(newPage));
        return newPage;
      });
    }
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      navigateToEnteredPage();
    }
  };

  //Todo Zoom debounce

  const isPreviousButtonDisabled = page === 1;
  const isNextButtonDisabled = page === maxPage;

  const handleCopyButtonClick = () => {
    navigator.clipboard.writeText(pdfUrl);
    toast.success("تم نسخ الرابط إلى الحافظة!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      toastId: TOAST_IDS.copySuccess,
    });
  };

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="my-modal">
      <Modal.Body closeButton style={{ justifyContent: "space-between" }}>
        <div className="container mt-3">
          <div className="row">
            <div className="col ColStyle" style={{ justifyContent: "end" }}>
              <Close onClick={handleClose} className="CloseBtnStyle" />
            </div>
            <div className="col-lg-auto ColStyle">
              <div className="CollNameStyle">{coll_name_arabic}</div>
            </div>
            <div className="col-md-auto ColStyle">
              <Calender className="IconStyle" />
              <div className="DataStyle">{fixedDate}</div>
            </div>
            <div className="col-md-auto ColStyle">
              <Compass className="IconStyle" />
              <div className="DataStyle">{coll_location_arabic}</div>
            </div>
            <div className="col-md-auto ColStyle">
              <Multiple className="IconStyle" />
              <div className="DataStyle">{coll_source_arabic}</div>
            </div>

            <div
              className="col-sm-auto ColStyle"
              style={{ justifyContent: "end" }}
            >
              <Button
                disabled={isNextButtonDisabled}
                onClick={handleNextPage}
                className="ButtonStyle"
              >
                <FontAwesomeIcon icon={faChevronLeft} />
                <span style={{ paddingLeft: "7px" }}>التالي</span>
              </Button>
            </div>
            <div
              className="col-sm-auto ColStyle"
              style={{ justifyContent: "center" }}
            >
              <Document className="IconStyle" />
              <div className="DataStyle">
                الصفحة {toArabicNumber(page.toString())} من{" "}
                {toArabicNumber(maxPage.toString())}
              </div>
            </div>
            <div
              className="col-sm-auto ColStyle"
              style={{ justifyContent: "start" }}
            >
              <Button
                disabled={isPreviousButtonDisabled}
                onClick={handlePreviousPage}
                className="ButtonStyle"
              >
                <span style={{ paddingRight: "7px" }}>السابق</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </Button>
            </div>
            <div
              className="col-sm-auto ColStyle"
              style={{ justifyContent: "end" }}
            >
              <Button
                onClick={handleCopyButtonClick}
                className="CopyButtonStyle"
              >
                <span style={{ paddingRight: "5px" }}> نسخ الرابط</span>
              </Button>
            </div>
            <div className="col-md-auto ColStyle">
              <label style={{ marginRight: "0.6rem" }}>
                الانتقال إلى الصفحة
              </label>
              <input
                type="text"
                value={enteredPageNumber}
                onChange={handlePageNumberChange}
                onKeyDown={handleEnterKey}
                className="PageNumberInput"
              />
            </div>
          </div>
          <div className="row">
            <strong>الاستشهاد:</strong>
            <span>
              {citationText}
              <Button
                style={{ marginLeft: "0.5rem" }}
                onClick={copyToClipboard}
                className="CopyButtonStyle"
              >
                <span style={{ paddingLeft: "5px" }}>نسخ الاستشهاد</span>
              </Button>
              {copySuccess && (
                <span style={{ color: "green", marginLeft: "10px" }}>
                  {copySuccess}
                </span>
              )}
            </span>
          </div>
        </div>

        {pdfUrl && (
          <div className="container mt-3">
            <Worker workerUrl={process.env.REACT_APP_PDF_WORKER}>
              <div>
                <Viewer
                  key={pdfUrl}
                  theme="dark"
                  fileUrl={pdfUrl}
                  plugins={viewerPluginInstances}
                />
              </div>
            </Worker>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PdfViewerModalArabic;
